import { IRootState, RootState } from "../root-state.store";
import { ActivityStatus } from "../../common/enums";
import {
  IReceptionParameter, ReceptionParameter,
  IReceptionDetailViewModel,
  IReceptionListingViewModel,
  IReceptionSectionListingViewModel,
  ReceptionDetailViewModel
} from "../../models/reception";
import { ReceptionService, IReceptionService } from "../../services";
import { IPagination, Pagination } from "../../models/generic";
import { RECEPTION_LOADERS } from "./reception-types.store";

export interface IReceptionState extends IRootState {
  receptionParameter?: IReceptionParameter;
  pagination?: IPagination;
  receptionSource?: {
    activityStatus: ActivityStatus
    detail: IReceptionDetailViewModel
  }
  receptionsSource?: {
    activityStatus: ActivityStatus;
    data?: IReceptionListingViewModel[]
  }
  receptionSections?: {
    activityStatus: ActivityStatus;
    data?: IReceptionSectionListingViewModel[]
  }
}
export class ReceptionState extends RootState<IReceptionService> implements IReceptionState {
  /**
   *
   */
  receptionParameter?: IReceptionParameter;
  receptionSource: {
    activityStatus: ActivityStatus;
    detail: IReceptionDetailViewModel
  }
  receptionsSource: {
    activityStatus: ActivityStatus;
    data: IReceptionListingViewModel[]
  }
  pagination?: IPagination;
  receptionSections?: {
    activityStatus: ActivityStatus;
    data?: IReceptionSectionListingViewModel[]
  }
  constructor() {
    super({
      activityStatus: ActivityStatus.NoActivity,
      service: new ReceptionService
    });
    this.pagination = new Pagination({ limit: 0, skip: 0, total: 0 })
    this.receptionParameter = new ReceptionParameter();
    this.receptionSections = {
      activityStatus: ActivityStatus.NoActivity,
      data: []
    }
    this.receptionSource = {
      activityStatus: ActivityStatus.NoActivity,
      detail: new ReceptionDetailViewModel
    }
    this.receptionsSource = {
      activityStatus: ActivityStatus.NoActivity,
      data: []
    }
    this.receptionSections = {
      activityStatus: ActivityStatus.NoActivity,
      data: []
    }
    this.loaders= new Map([
      [RECEPTION_LOADERS.LIST,false],
      [RECEPTION_LOADERS.FILTERS,false],
      [RECEPTION_LOADERS.SIDEBAR,false],
      [RECEPTION_LOADERS.DETAILS,false]
    ])
  }
}


// WEBPACK FOOTER //
// ./src/store/reception/reception-state.store.ts